/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AddressesRequestBuilderNavigationMetadata, type AddressesRequestBuilder } from './addresses/index.js';
// @ts-ignore
import { AnalyticsRequestBuilderNavigationMetadata, type AnalyticsRequestBuilder } from './analytics/index.js';
// @ts-ignore
import { AuthRequestBuilderNavigationMetadata, type AuthRequestBuilder } from './auth/index.js';
// @ts-ignore
import { CampaignsRequestBuilderNavigationMetadata, CampaignsRequestBuilderRequestsMetadata, type CampaignsRequestBuilder } from './campaigns/index.js';
// @ts-ignore
import { CartsRequestBuilderNavigationMetadata, CartsRequestBuilderRequestsMetadata, type CartsRequestBuilder } from './carts/index.js';
// @ts-ignore
import { CategoriesRequestBuilderNavigationMetadata, CategoriesRequestBuilderRequestsMetadata, type CategoriesRequestBuilder } from './categories/index.js';
// @ts-ignore
import { CommissionsRequestBuilderNavigationMetadata, type CommissionsRequestBuilder } from './commissions/index.js';
// @ts-ignore
import { CompanydocsRequestBuilderNavigationMetadata, type CompanydocsRequestBuilder } from './companydocs/index.js';
// @ts-ignore
import { ConfigRequestBuilderRequestsMetadata, type ConfigRequestBuilder } from './config/index.js';
// @ts-ignore
import { ContactsRequestBuilderRequestsMetadata, type ContactsRequestBuilder } from './contacts/index.js';
// @ts-ignore
import { CustomersRequestBuilderNavigationMetadata, CustomersRequestBuilderRequestsMetadata, type CustomersRequestBuilder } from './customers/index.js';
// @ts-ignore
import { DataImportsRequestBuilderNavigationMetadata, type DataImportsRequestBuilder } from './dataImports/index.js';
// @ts-ignore
import { DatamappingsRequestBuilderNavigationMetadata, DatamappingsRequestBuilderRequestsMetadata, type DatamappingsRequestBuilder } from './datamappings/index.js';
// @ts-ignore
import { EmailsRequestBuilderNavigationMetadata, type EmailsRequestBuilder } from './emails/index.js';
// @ts-ignore
import { ExportsRequestBuilderNavigationMetadata, ExportsRequestBuilderRequestsMetadata, type ExportsRequestBuilder } from './exports/index.js';
// @ts-ignore
import { FavoritesRequestBuilderNavigationMetadata, type FavoritesRequestBuilder } from './favorites/index.js';
// @ts-ignore
import { FeatureFlagsRequestBuilderRequestsMetadata, type FeatureFlagsRequestBuilder } from './featureFlags/index.js';
// @ts-ignore
import { FlipbooksRequestBuilderNavigationMetadata, FlipbooksRequestBuilderRequestsMetadata, type FlipbooksRequestBuilder } from './flipbooks/index.js';
// @ts-ignore
import { ForecastingRequestBuilderNavigationMetadata, type ForecastingRequestBuilder } from './forecasting/index.js';
// @ts-ignore
import { ImagesRequestBuilderNavigationMetadata, ImagesRequestBuilderRequestsMetadata, type ImagesRequestBuilder } from './images/index.js';
// @ts-ignore
import { IntegrationsRequestBuilderNavigationMetadata, type IntegrationsRequestBuilder } from './integrations/index.js';
// @ts-ignore
import { IntegrationTemplatesRequestBuilderRequestsMetadata, type IntegrationTemplatesRequestBuilder } from './integrationTemplates/index.js';
// @ts-ignore
import { InvoicesRequestBuilderNavigationMetadata, InvoicesRequestBuilderRequestsMetadata, type InvoicesRequestBuilder } from './invoices/index.js';
// @ts-ignore
import { JobsRequestBuilderNavigationMetadata, type JobsRequestBuilder } from './jobs/index.js';
// @ts-ignore
import { MapsRequestBuilderNavigationMetadata, type MapsRequestBuilder } from './maps/index.js';
// @ts-ignore
import { MessagecenterRequestBuilderNavigationMetadata, type MessagecenterRequestBuilder } from './messagecenter/index.js';
// @ts-ignore
import { OrdersRequestBuilderNavigationMetadata, OrdersRequestBuilderRequestsMetadata, type OrdersRequestBuilder } from './orders/index.js';
// @ts-ignore
import { OrganizationRequestBuilderNavigationMetadata, OrganizationRequestBuilderRequestsMetadata, type OrganizationRequestBuilder } from './organization/index.js';
// @ts-ignore
import { OrganizationsRequestBuilderNavigationMetadata, OrganizationsRequestBuilderRequestsMetadata, type OrganizationsRequestBuilder } from './organizations/index.js';
// @ts-ignore
import { PaymentsRequestBuilderNavigationMetadata, type PaymentsRequestBuilder } from './payments/index.js';
// @ts-ignore
import { ProductFamiliesRequestBuilderNavigationMetadata, ProductFamiliesRequestBuilderRequestsMetadata, type ProductFamiliesRequestBuilder } from './productFamilies/index.js';
// @ts-ignore
import { ProductsRequestBuilderNavigationMetadata, ProductsRequestBuilderRequestsMetadata, type ProductsRequestBuilder } from './products/index.js';
// @ts-ignore
import { QuickbooksRequestBuilderNavigationMetadata, type QuickbooksRequestBuilder } from './quickbooks/index.js';
// @ts-ignore
import { SalesrepsRequestBuilderNavigationMetadata, type SalesrepsRequestBuilder } from './salesreps/index.js';
// @ts-ignore
import { SignupsRequestBuilderNavigationMetadata, type SignupsRequestBuilder } from './signups/index.js';
// @ts-ignore
import { SqlConnectorRequestBuilderNavigationMetadata, SqlConnectorRequestBuilderRequestsMetadata, type SqlConnectorRequestBuilder } from './sqlConnector/index.js';
// @ts-ignore
import { TasksRequestBuilderNavigationMetadata, TasksRequestBuilderRequestsMetadata, type TasksRequestBuilder } from './tasks/index.js';
// @ts-ignore
import { type UsersRequestBuilder, UsersRequestBuilderNavigationMetadata, UsersRequestBuilderRequestsMetadata } from './users/index.js';
// @ts-ignore
import { type V1RequestBuilder, V1RequestBuilderNavigationMetadata } from './v1/index.js';
// @ts-ignore
import { type VendorsRequestBuilder, VendorsRequestBuilderNavigationMetadata, VendorsRequestBuilderRequestsMetadata } from './vendors/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api
 */
export interface ApiRequestBuilder extends BaseRequestBuilder<ApiRequestBuilder> {
    /**
     * The addresses property
     */
    get addresses(): AddressesRequestBuilder;
    /**
     * The analytics property
     */
    get analytics(): AnalyticsRequestBuilder;
    /**
     * The auth property
     */
    get auth(): AuthRequestBuilder;
    /**
     * The campaigns property
     */
    get campaigns(): CampaignsRequestBuilder;
    /**
     * The carts property
     */
    get carts(): CartsRequestBuilder;
    /**
     * The categories property
     */
    get categories(): CategoriesRequestBuilder;
    /**
     * The commissions property
     */
    get commissions(): CommissionsRequestBuilder;
    /**
     * The companydocs property
     */
    get companydocs(): CompanydocsRequestBuilder;
    /**
     * The config property
     */
    get config(): ConfigRequestBuilder;
    /**
     * The contacts property
     */
    get contacts(): ContactsRequestBuilder;
    /**
     * The customers property
     */
    get customers(): CustomersRequestBuilder;
    /**
     * The dataImports property
     */
    get dataImports(): DataImportsRequestBuilder;
    /**
     * The datamappings property
     */
    get datamappings(): DatamappingsRequestBuilder;
    /**
     * The emails property
     */
    get emails(): EmailsRequestBuilder;
    /**
     * The exports property
     */
    get exports(): ExportsRequestBuilder;
    /**
     * The favorites property
     */
    get favorites(): FavoritesRequestBuilder;
    /**
     * The featureFlags property
     */
    get featureFlags(): FeatureFlagsRequestBuilder;
    /**
     * The flipbooks property
     */
    get flipbooks(): FlipbooksRequestBuilder;
    /**
     * The forecasting property
     */
    get forecasting(): ForecastingRequestBuilder;
    /**
     * The images property
     */
    get images(): ImagesRequestBuilder;
    /**
     * The integrations property
     */
    get integrations(): IntegrationsRequestBuilder;
    /**
     * The integrationTemplates property
     */
    get integrationTemplates(): IntegrationTemplatesRequestBuilder;
    /**
     * The invoices property
     */
    get invoices(): InvoicesRequestBuilder;
    /**
     * The jobs property
     */
    get jobs(): JobsRequestBuilder;
    /**
     * The maps property
     */
    get maps(): MapsRequestBuilder;
    /**
     * The messagecenter property
     */
    get messagecenter(): MessagecenterRequestBuilder;
    /**
     * The orders property
     */
    get orders(): OrdersRequestBuilder;
    /**
     * The organization property
     */
    get organization(): OrganizationRequestBuilder;
    /**
     * The organizations property
     */
    get organizations(): OrganizationsRequestBuilder;
    /**
     * The payments property
     */
    get payments(): PaymentsRequestBuilder;
    /**
     * The productFamilies property
     */
    get productFamilies(): ProductFamiliesRequestBuilder;
    /**
     * The products property
     */
    get products(): ProductsRequestBuilder;
    /**
     * The quickbooks property
     */
    get quickbooks(): QuickbooksRequestBuilder;
    /**
     * The salesreps property
     */
    get salesreps(): SalesrepsRequestBuilder;
    /**
     * The signups property
     */
    get signups(): SignupsRequestBuilder;
    /**
     * The sqlConnector property
     */
    get sqlConnector(): SqlConnectorRequestBuilder;
    /**
     * The tasks property
     */
    get tasks(): TasksRequestBuilder;
    /**
     * The users property
     */
    get users(): UsersRequestBuilder;
    /**
     * The v1 property
     */
    get v1(): V1RequestBuilder;
    /**
     * The vendors property
     */
    get vendors(): VendorsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ApiRequestBuilderUriTemplate = "{+baseurl}/api";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ApiRequestBuilderNavigationMetadata: Record<Exclude<keyof ApiRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    addresses: {
        navigationMetadata: AddressesRequestBuilderNavigationMetadata,
    },
    analytics: {
        navigationMetadata: AnalyticsRequestBuilderNavigationMetadata,
    },
    auth: {
        navigationMetadata: AuthRequestBuilderNavigationMetadata,
    },
    campaigns: {
        requestsMetadata: CampaignsRequestBuilderRequestsMetadata,
        navigationMetadata: CampaignsRequestBuilderNavigationMetadata,
    },
    carts: {
        requestsMetadata: CartsRequestBuilderRequestsMetadata,
        navigationMetadata: CartsRequestBuilderNavigationMetadata,
    },
    categories: {
        requestsMetadata: CategoriesRequestBuilderRequestsMetadata,
        navigationMetadata: CategoriesRequestBuilderNavigationMetadata,
    },
    commissions: {
        navigationMetadata: CommissionsRequestBuilderNavigationMetadata,
    },
    companydocs: {
        navigationMetadata: CompanydocsRequestBuilderNavigationMetadata,
    },
    config: {
        requestsMetadata: ConfigRequestBuilderRequestsMetadata,
    },
    contacts: {
        requestsMetadata: ContactsRequestBuilderRequestsMetadata,
    },
    customers: {
        requestsMetadata: CustomersRequestBuilderRequestsMetadata,
        navigationMetadata: CustomersRequestBuilderNavigationMetadata,
    },
    dataImports: {
        navigationMetadata: DataImportsRequestBuilderNavigationMetadata,
    },
    datamappings: {
        requestsMetadata: DatamappingsRequestBuilderRequestsMetadata,
        navigationMetadata: DatamappingsRequestBuilderNavigationMetadata,
    },
    emails: {
        navigationMetadata: EmailsRequestBuilderNavigationMetadata,
    },
    exports: {
        requestsMetadata: ExportsRequestBuilderRequestsMetadata,
        navigationMetadata: ExportsRequestBuilderNavigationMetadata,
    },
    favorites: {
        navigationMetadata: FavoritesRequestBuilderNavigationMetadata,
    },
    featureFlags: {
        requestsMetadata: FeatureFlagsRequestBuilderRequestsMetadata,
    },
    flipbooks: {
        requestsMetadata: FlipbooksRequestBuilderRequestsMetadata,
        navigationMetadata: FlipbooksRequestBuilderNavigationMetadata,
    },
    forecasting: {
        navigationMetadata: ForecastingRequestBuilderNavigationMetadata,
    },
    images: {
        requestsMetadata: ImagesRequestBuilderRequestsMetadata,
        navigationMetadata: ImagesRequestBuilderNavigationMetadata,
    },
    integrations: {
        navigationMetadata: IntegrationsRequestBuilderNavigationMetadata,
    },
    integrationTemplates: {
        requestsMetadata: IntegrationTemplatesRequestBuilderRequestsMetadata,
    },
    invoices: {
        requestsMetadata: InvoicesRequestBuilderRequestsMetadata,
        navigationMetadata: InvoicesRequestBuilderNavigationMetadata,
    },
    jobs: {
        navigationMetadata: JobsRequestBuilderNavigationMetadata,
    },
    maps: {
        navigationMetadata: MapsRequestBuilderNavigationMetadata,
    },
    messagecenter: {
        navigationMetadata: MessagecenterRequestBuilderNavigationMetadata,
    },
    orders: {
        requestsMetadata: OrdersRequestBuilderRequestsMetadata,
        navigationMetadata: OrdersRequestBuilderNavigationMetadata,
    },
    organization: {
        requestsMetadata: OrganizationRequestBuilderRequestsMetadata,
        navigationMetadata: OrganizationRequestBuilderNavigationMetadata,
    },
    organizations: {
        requestsMetadata: OrganizationsRequestBuilderRequestsMetadata,
        navigationMetadata: OrganizationsRequestBuilderNavigationMetadata,
    },
    payments: {
        navigationMetadata: PaymentsRequestBuilderNavigationMetadata,
    },
    productFamilies: {
        requestsMetadata: ProductFamiliesRequestBuilderRequestsMetadata,
        navigationMetadata: ProductFamiliesRequestBuilderNavigationMetadata,
    },
    products: {
        requestsMetadata: ProductsRequestBuilderRequestsMetadata,
        navigationMetadata: ProductsRequestBuilderNavigationMetadata,
    },
    quickbooks: {
        navigationMetadata: QuickbooksRequestBuilderNavigationMetadata,
    },
    salesreps: {
        navigationMetadata: SalesrepsRequestBuilderNavigationMetadata,
    },
    signups: {
        navigationMetadata: SignupsRequestBuilderNavigationMetadata,
    },
    sqlConnector: {
        requestsMetadata: SqlConnectorRequestBuilderRequestsMetadata,
        navigationMetadata: SqlConnectorRequestBuilderNavigationMetadata,
    },
    tasks: {
        requestsMetadata: TasksRequestBuilderRequestsMetadata,
        navigationMetadata: TasksRequestBuilderNavigationMetadata,
    },
    users: {
        requestsMetadata: UsersRequestBuilderRequestsMetadata,
        navigationMetadata: UsersRequestBuilderNavigationMetadata,
    },
    v1: {
        navigationMetadata: V1RequestBuilderNavigationMetadata,
    },
    vendors: {
        requestsMetadata: VendorsRequestBuilderRequestsMetadata,
        navigationMetadata: VendorsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
